import { render, staticRenderFns } from "./PlanMembresias.vue?vue&type=template&id=36df61b2"
import script from "./PlanMembresias.vue?vue&type=script&lang=js"
export * from "./PlanMembresias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports